module.exports = __webpack_public_path__ + "img/usericone.80dc2fdf.png";